import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { Button, Col, Divider, Icon, Row, Form } from 'antd';

import moment from 'moment';

// Filter fields
import ServiceTypes from './fields/ServiceTypes';
import Passengers from './fields/Passengers';
import Drivers from './fields/Drivers';
// import Responsible from './fields/Responsible';
import Arrival from './fields/Arrival';
import Cost from './fields/Cost';
// import Executors from './fields/Executors';
// import Watcher from './fields/Watcher';
import Regions from './fields/Regions';
import WeekDays from './fields/WeekDays';
import StatusPayment from './fields/StatusPayment';
import PaymentMethods from './fields/PaymentMethods';
import CustomerAcceptance from './fields/CustomerAcceptance';
import Carriers from './fields/Carriers';
import './Filters.css';
import DocumentTypes from './fields/DocumentTypes';
import ResponsiblePerson from './fields/ResponsiblePerson';
import Observer from './fields/Observer';

class Filters extends React.PureComponent {
  render() {
    const {
      showFilterAll, // не рефакторил
      showDrawer, // не рефакторил
      toggleAllFilter, // не рефакторил
      // работа с фильтрами
      form,
    } = this.props;
    return (
      <div className="b-table-filters">
        <Row>
          <Col span={6}>
            <ServiceTypes form={form} />
          </Col>
          <Col span={6}>
            <DocumentTypes form={form} />
          </Col>
          {/*<Col span={6}>*/}
          {/*  <Passengers form={form} />*/}
          {/*</Col>*/}
          <Col span={6}>
            <Drivers form={form} />
          </Col>
          <Col span={6}>
            <ResponsiblePerson form={form} />
          </Col>
          {/*<Col span={6}>*/}
          {/*  <Arrival form={form} />*/}
          {/*</Col>*/}
        </Row>
        <Row>
          <Col span={6}>
            <Arrival form={form} />
          </Col>
          <Col span={6} />
          {!showFilterAll && (
            <Fragment>
              <Col span={6} align="right" className="b-table-filters__no-label">
                <Button
                  type="link"
                  className="withIcon withIcon_setting right"
                  onClick={showDrawer}
                >
                  Настроить столбцы
                  <Icon type="setting" />
                </Button>
              </Col>
              <Col span={6} align="right" className="b-table-filters__no-label">
                <Button
                  onClick={toggleAllFilter}
                  type="link"
                  className="withIcon small right"
                >
                  Показать еще фильтры
                  <Icon style={{ fontSize: '12px' }} type="down" />
                </Button>
              </Col>
            </Fragment>
          )}
        </Row>
        {showFilterAll && (
          <Fragment>
            <Divider style={{ height: 1, backgroundColor: '#d9d9d9' }} />
            <Row>
              <Col span={6}>
                <Regions form={form} />
              </Col>
              <Col span={6}>
                <WeekDays form={form} />
              </Col>
              <Col span={6}>
                <Passengers form={form} />
              </Col>
              {/*<Col span={6}>*/}
              {/*  <RouteLength form={form} />*/}
              {/*</Col>*/}
              {/*<Col span={6}>*/}
              {/*  <Vehicle form={form} />*/}
              {/*</Col>*/}
              <Col span={6}>
                <Cost form={form} />
              </Col>
            </Row>
            <Row>
              <Col span={6}>
                <StatusPayment form={form} />
              </Col>
              <Col span={6}>
                <PaymentMethods form={form} />
              </Col>
              <Col span={6}>
                <Observer form={form} />
              </Col>
              {/*<Col span={6}>*/}
              {/*  <ReservationDate form={form} />*/}
              {/*</Col>*/}
              {/*<Col span={6}>*/}
              {/*  <OfferEndDate form={form} />*/}
              {/*</Col>*/}
              <Col span={6}>
                <CustomerAcceptance form={form} />
              </Col>
            </Row>
            <Row>
              <Col span={6}>
                <Carriers form={form} />
              </Col>
            </Row>
            <Divider style={{ height: 1, backgroundColor: '#d9d9d9' }} />
            <Row>
              <Col span={6} />
              <Col span={6} />
              {showFilterAll && (
                <Fragment>
                  <Col span={6} align="right">
                    <Button
                      type="link"
                      className="withIcon withIcon_setting right"
                      onClick={showDrawer}
                    >
                      Настроить столбцы
                      <Icon type="setting" />
                    </Button>
                  </Col>
                  <Col span={6} align="right">
                    <Button
                      onClick={toggleAllFilter}
                      className="orders__button-custom"
                      type="link"
                    >
                      Скрыть фильтры
                      <Icon style={{ fontSize: '12px' }} type="up" />
                    </Button>
                  </Col>
                </Fragment>
              )}
            </Row>
          </Fragment>
        )}
      </div>
    );
  }
}

class FiltersData extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  getValueByFieldName(name, val) {
    if (name.includes('Date')) {
      return (val && moment(val)) || null;
    } else {
      return val;
    }
  }

  saveFormRef = formRef => {
    if (formRef && formRef.props && formRef.props.form) {
      this.formRef = formRef.props.form;
    } else {
      this.formRef = null;
    }
    // this.props.setForm(this.props.name, this.formRef);
  };

  render() {
    return (
      <FormOrderFilter
        {...this.props}
        wrappedComponentRef={this.saveFormRef}
        getValueByFieldName={this.getValueByFieldName}
      />
    );
  }
}

const FormOrderFilter = Form.create({
  name: 'orderFilters',
  onFieldsChange(props, changedFields) {
    props.handleFiltersChange(props.form.getFieldsValue());
  },
  mapPropsToFields(props) {
    let obj = {};
    props.data &&
      Object.keys(props.data).forEach(name => {
        obj[name] = Form.createFormField({
          value: props.getValueByFieldName(name, props.data[name]),
        });
      });
    return obj;
  },
  onValuesChange(props, values) {},
})(Filters);

export default connect(state => ({
  data: state.Executorship.Orders.filters.fields,
}))(FiltersData);
